import { restClient } from '@/Core'

import { toShareRow } from '../Helpers/diskResponse'

import type { DiskRole } from '../Contracts/DiskNode'
import type { DiskShareRow } from '../Contracts/DiskShare'

/** Змінити роль чи строк рядка: `PATCH /services/disk/shares/{uuid}` (`expiresAt: null` — без строку). */
export const UpdateDiskShareTask = async (
    uuid: string,
    patch: { role?: DiskRole; expiresAt?: string | null }
): Promise<DiskShareRow> => {
    const response = (await restClient.patch(`/services/disk/shares/${encodeURIComponent(uuid)}`, {
        json: patch,
    })) as unknown

    return toShareRow(response)
}
